<template>
  <div id="main-wrapper" v-bind:class="{ 'show-sidebar': mobileSidebarSHow }">
    <NewFeatureModal
      v-if="newFeatureModal"
      :show="newFeatureModal"
      @close="closeNewFeatureModal"
      :side="side"
    />
    <Terms
      :showAgreement="showAgreement"
      @agreed="agreed"
      dashboard
      v-if="showAgreement"
      @logoutUser="declineAgreement"
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <header class="topbar">
      <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-header">
          <!-- This is for the sidebar toggle which is visible on mobile only -->
          <a
            id="mobileclosebutton"
            class="nav-toggler waves-effect waves-light d-block d-md-none"
            href="#"
          >
            <em
              @click="mobileSidebar"
              :class="mobileSidebarSHow ? 'ti-close' : 'ti-menu'"
            ></em>
          </a>
          <div class="navbar-brand justify-content-center">
            <!-- Logo icon -->
            <b class="logo-icon">
              <!-- <img
                :src="this.businessprofile.image"
                alt="homepage"
                height="30"
                class="light-logo"
                v-if="this.businessprofile.image"
              /> -->
              <img
                src="../assets/images/logo.png"
                alt="homepage"
                height="30"
                class="light-logo"
              />
            </b>
          </div>
          <!-- <a
            class="topbartoggler d-block d-md-none waves-effect waves-light"
            href="#"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i @click="profileIcon" class="ti-more"></i>
          </a> -->

          <div
            class="d-flex justify-content-end align-items-center flex-grow mr-3 d-md-none"
          >
            <div style="position:relative" v-click-outside="hideDrop2">
              <div
                class="d-flex align-items-center cursor-pointer"
                style="column-gap:1rem"
                @click="show_drop2 = !show_drop2"
              >
                <div class="d-flex align-items-center">
                  <span class="mr-2" style="color: #5E6A79;">{{
                    language
                  }}</span>
                  <IconDownArrow />
                </div>
              </div>
              <div
                class="dropdown-lang position-absolute p-10"
                v-if="show_drop2"
              >
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem;height: 2.5rem;"
                  @click="updateLang('en')"
                >
                  <input
                    type="radio"
                    class="radio-btn"
                    :checked="language === 'EN'"
                  />
                  <span style="color: #5E6A79;">English - EN</span>
                </span>
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem;height: 2.5rem;"
                  @click="updateLang('fr')"
                >
                  <input type="radio" :checked="language === 'FR'" />
                  <span style="color: #5E6A79;">French - FR</span>
                </span>
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem;height: 2.5rem;"
                  @click="updateLang('sw')"
                >
                  <input type="radio" :checked="language === 'SW'" />
                  <span style="color: #5E6A79;">Swahili - SW</span>
                </span>
              </div>
            </div>
          </div>

          <span
            class=" topbartoggler d-block d-md-none waves-effect waves-light d-flex cursor-pointer align-items-center"
            @click.stop="headerShow = !headerShow"
          >
            <div class="circle rounded-circle mr-2">
              <p class="inside-circle">{{ getFirstLetter }}</p>
            </div>
            <span style="align-self:center" class="mr-4">
              <IconDropdown />
            </span>
          </span>
        </div>
        <div
          class="navbar-collapse collapse"
          id="navbarSupportedContent"
          data-navbarbg="skin6"
        >
          <div
            v-if="isChildPage()"
            @click="goBack"
            class="d-flex align-items-center col-gap-1 cursor-pointer"
          >
            <img
              src="../assets/images/mapinnerShow.svg"
              alt=""
              style="transform: rotate(90deg)"
            />
            <p class="text-primary font-14 mb-0">
              Back
            </p>
          </div>
          <p v-else class="gray3 mb-0" style="text-transform:capitalize">
            {{ currentModule() }}
          </p>

          <div
            class="d-flex justify-content-end align-items-center flex-grow mr-3"
          >
            <div style="position:relative" v-click-outside="hideDrop">
              <div
                class="d-flex align-items-center cursor-pointer"
                style="column-gap:1rem"
                @click="show_drop = !show_drop"
              >
                <!-- <p class="mb-0" style="color: #5E6A79;">
                  {{ $t("change-lang") }}
                </p> -->
                <div class="d-flex align-items-center">
                  <span class="mr-2" style="color: #5E6A79;">{{
                    language
                  }}</span>
                  <IconDownArrow />
                </div>
              </div>
              <div
                class="dropdown-lang position-absolute p-10"
                v-if="show_drop"
              >
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem;"
                  @click="updateLang('en')"
                >
                  <input
                    type="radio"
                    class="radio-btn"
                    :checked="language === 'EN'"
                  />
                  <span style="color: #5E6A79;">English - EN</span>
                </span>
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem"
                  @click="updateLang('fr')"
                >
                  <input type="radio" :checked="language === 'FR'" />
                  <span style="color: #5E6A79;">French - FR</span>
                </span>
                <span
                  class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                  style="column-gap:0.7rem;height: 2.5rem;"
                  @click="updateLang('sw')"
                >
                  <input type="radio" :checked="language === 'SW'" />
                  <span style="color: #5E6A79;">Swahili - SW</span>
                </span>
              </div>
            </div>
          </div>

          <ul class="navbar-nav float-right">
            <span
              class="d-flex cursor-pointer d-xs-none"
              @click.stop="headerShow = !headerShow"
            >
              <li
                class="gray4 mr-2 name-text"
                style="display:flex; align-items: center"
              >
                {{ profile.fullname }}
              </li>
              <div class="circle rounded-circle mr-2">
                <p class="inside-circle">{{ getFirstLetter }}</p>
              </div>
              <span style="align-self:center" class="mr-4">
                <IconDropdown />
              </span>
            </span>
          </ul>

          <!-- Test change Lang -->
          <!-- <div class="lang">
            <select v-model="$i18n.locale">
              <option
                v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                :value="lang"
                >{{ lang }}</option
              >
            </select>
          </div> -->
        </div>
        <div class="nav-item" style="position:initial;" v-if="headerShow">
          <div
            v-bind:class="{ show: headerShow }"
            v-click-outside="closeHeader"
            class="dropdown-menu dropdown-menu-right move-right"
            style="padding:0.5rem 1rem"
          >
            <div class="profile-dis scrollable">
              <div class="">
                <div
                  class="top-name d-flex align-items-center"
                  style="column-gap: 5px;"
                >
                  <div class="circle rounded-circle">
                    <p class="inside-circle">{{ getFirstLetter }}</p>
                  </div>
                  <!-- <div class="circle">1</div> -->
                  <div
                    style="display:flex"
                    class="flex-column m-b-10 m-l-10 m-t-10"
                  >
                    <!-- <span @click="headerShow = false" className="mb-1">{{
                      $t("acc")
                    }}</span> -->

                    <span style="text-transform: capitalize;" class="font-18">{{
                      profile.fullname.split(" ")[0]
                    }}</span>
                    <span class="mb-1 font-14 gray4">{{ profile.email }}</span>
                  </div>
                </div>
                <span class="d-flex col-gap-1 align-items-center hover-item">
                  <IconSettings class="container-icon" />
                  <router-link style="color: #6a7a8c" to="/settings/profile">{{
                    $t("settings")
                  }}</router-link>
                </span>
                <span class="d-flex col-gap-1 align-items-center hover-item">
                  <IconSupport class="container-icon" />
                  <router-link style="color: #6a7a8c" to="/support">{{
                    $t("support")
                  }}</router-link>
                </span>
                <span
                  class="d-flex col-gap-1 align-items-center hover-item  cursor-pointer"
                  @click="openSidePop"
                >
                  <IconGift class="container-icon" />
                  {{ $t("what") }}
                  <span class="ml-2 mb-0 new-feat">
                    {{ $t("new") }}
                  </span>
                </span>
                <hr class="mt-3 mb-0" />
                <span
                  @click.prevent="logoutUser"
                  style="cursor: pointer"
                  class="d-flex col-gap-1 hover-item align-items-center text-error"
                >
                  <IconLogOut
                    class="container-icon"
                    style="transform: rotate(90deg)"
                  />
                  {{ $t("logout") }}
                </span>

                <!-- <div
                      @click.prevent="logoutUser"
                      style="cursor: pointer"
                      class="dropdown-item"
                    >
                      Logout
                    </div> -->
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <aside class="left-sidebar">
      <nav class="sidebar-nav position-relative" aria-label="side-bar menu">
        <ul id="sidebarnav">
          <li
            @click="mobileSidebarSHow = false"
            class="sidebar-item tooltip"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('dashboard-title') +
                '</h5><br>' +
                $t('dashboard-description')
            "
            data-tooltipClass="customTooltip"
            :data-title="$t('dashboard-title')"
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/dashboard"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconDashboard class="container-icon" />
                  <span class="ml-3 hide-menu">{{ $t("dashboard") }}</span>
                </div>
              </div>
            </router-link>
          </li>
          <li
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('my-devices-title') +
                '</h5><br>' +
                $t('my-devices-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/devices"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconDevices class="container-icon" />
                  <span class="ml-3 hide-menu">{{ $t("devices") }}</span>
                </div>
              </div>
            </router-link>
          </li>
          <li
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('groups-title') +
                '</h5><br>' +
                $t('groups-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/groups"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconGroups class="container-icon" />
                  <span class="ml-3 hide-menu">{{ $t("groups") }}</span>
                </div>
              </div>
            </router-link>
          </li>
          <li
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('live-map-title') +
                '</h5><br>' +
                $t('live-map-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/maps"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconMap class="container-icon" />
                  <span class="ml-3 hide-menu mr-4">{{ $t("maps") }}</span>
                </div>
              </div>

              <!-- <img
                v-if="!mapInner"
                src="../assets/images/mapinnerShow.svg"
                alt=""
              />
              <img v-else src="../assets/images/mapinnerHide.svg" alt="" /> -->
            </router-link>
          </li>
          <!-- <div v-if="mapInner">
            <li
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              :class="{ show: createPOI, 'poi-disabled': POIdisabled }"
              @click="createpoi"
            >
              {{ $t("create-poi") }}
            </li>
            <li
              :class="{
                show: createGeofence,
                'geofence-disabled': geofencedisabled,
              }"
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              @click="creategeofence"
            >
              {{ $t("create_geo") }}
            </li>
          </div> -->

          <!-- <li v-show="profile.role !== 'staff'" @click="mobileSidebarSHow = false" class="sidebar-item">
            <router-link
              class="sidebar-link waves-effect waves-dark sidebar-link active"
              to="/subscriptions"
              aria-expanded="false"
            >
              <i class="icon-wallet"></i>
              <span class="ml-3 hide-menu">Subscriptions</span>
            </router-link>
          </li> -->
          <!-- <li
            v-show="profile.role !== 'staff'"
            @click="
              mobileSidebarSHow = false;
              showRecs = !showRecs;
            "
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('records-title') +
                '</h5><br>' +
                $t('records-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              :class="
                $route.path.split('/')[1] === 'dispatch' &&
                  'router-link-active router-link-exact-active'
              "
              to="/records"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconRecords class="container-icon" />
                  <span class="ml-3 hide-menu mr-4">{{ $t("records") }}</span>
                </div>
              </div>
            </router-link>
          </li> -->
          <!-- <div v-if="showRecs">
            <li
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              :class="{ show: $route.path.split('/')[1] === 'records' }"
              @click="createrec"
            >
              {{ $t("records") }}
            </li>
            <li
              :class="{
                show: $route.path.split('/')[1] === 'dispatch',
              }"
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              @click="createDis"
            >
              {{ $t("dispatch") }}
            </li>
          </div> -->
          <li
            v-show="profile.role !== 'staff'"
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('alarms-title') +
                '</h5><br>' +
                $t('alarms-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/alarms"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconAlarm class="" />
                  <span class="ml-3 hide-menu d-flex align-items-center"
                    >{{ $t("alarms") }}
                  </span>
                </div>
              </div>
            </router-link>
          </li>
          <li
            v-show="profile.role !== 'staff'"
            v-on:click="
              () => {
                showSub = !showSub;
              }
            "
            class="sidebar-item"
            :class="
              $route.path.split('/')[1] === 'subscription' &&
                'router-link-active router-link-exact-active'
            "
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('wallets-title') +
                '</h5><br>' +
                $t('wallets-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/wallet"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconWallet class="" />
                  <span class="ml-3 hide-menu d-flex align-items-center mr-4"
                    >{{ $t("payment") }}
                  </span>
                  <img
                    v-if="!showSub"
                    src="../assets/images/mapinnerShow.svg"
                    alt=""
                  />
                  <img v-else src="../assets/images/mapinnerHide.svg" alt="" />
                </div>
              </div>
            </router-link>
          </li>
          <div v-if="showSub">
            <li
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              :class="{ show: $route.path.split('/')[1] === 'wallet' }"
              @click="createwal"
            >
              {{ $t("wallet") }}
            </li>
            <!-- <li
              :class="{
                show: $route.path.split('/')[1] === 'subscription',
              }"
              class="d-flex sidebar-item px-5 py-3 font-16 sidebar-inneritem"
              @click="createsub"
            >
              {{ $t("subscription") }}
            </li> -->
          </div>

          <li
            v-show="profile.role !== 'staff'"
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
            :data-intro="
              '<h5 style=\'margin-bottom: 1rem; font-weight: 600;font-size: 16px; color: #404A57\'>' +
                $t('reports-title') +
                '</h5><br>' +
                $t('reports-description')
            "
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/reports"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconReport class="" />
                  <span class="ml-3 hide-menu d-flex align-items-center"
                    >{{ $t("reports") }}
                  </span>
                </div>
              </div>
            </router-link>
          </li>

          <li
            v-show="profile.role !== 'staff'"
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
          >
            <router-link
              to="/users"
              class="waves-effect d-flex align-items-center"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconUsers class="container-icon" />
                  <span class="ml-3 hide-menu">{{ $t("users") }}</span>
                </div>
              </div>
            </router-link>
          </li>

          <!-- <li
            v-show="profile.role !== 'staff'"
            @click="mobileSidebarSHow = false"
            class="sidebar-item"
          >
            <router-link
              class="waves-effect d-flex align-items-center"
              to="/logs"
              aria-expanded="false"
              active-class="active-link"
            >
              <div class="d-flex w-100 ">
                <div class="line"></div>
                <div
                  class="d-flex sidebar-link flex-grow-1 ml-2 rounded-left-pill icon-label"
                >
                  <IconAudit class="container-icon" />
                  <span class="ml-3 hide-menu">{{ $t("audit") }}</span>
                </div>
              </div>
            </router-link>
          </li> -->

          <!-- <li class="sidebar-item">
            <div
              @click.prevent="logoutUser"
              style="cursor: pointer"
              to="#"
              class="sidebar-link waves-effect waves-dark sidebar-link active"
              aria-expanded="false"
            >
              <IconPower class="container-icon" />
              <span class="ml-3 hide-menu">{{ $t("logout") }}</span>
            </div>
          </li> -->
        </ul>
      </nav>
    </aside>

    <router-view
      :createPOI="createPOI"
      :createGeofence="createGeofence"
      v-on:closeCreateGeofence="createGeofence = false"
      v-on:closeCreatePOI="createPOI = false"
      v-on:closemapInner="mapInner = false"
      v-on:hideRecords="showRecs = false"
      v-on:hideWallet="showSub = false"
      v-on:disable-geoCreate="geofencedisabled = !geofencedisabled"
      v-on:disable-POICreate="POIdisabled = !POIdisabled"
    />
  </div>
</template>

<script>
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import NewFeatureModal from "../views/Modals/NewFeatureModal.vue";
import IconDashboard from "../components/Iconsvg/IconDashboard";
import IconGroups from "../components/Iconsvg/IconGroups";
import IconDevices from "../components/Iconsvg/IconDevices";
import IconAudit from "../components/Iconsvg/IconAudit";
import IconPower from "../components/Iconsvg/IconPower";
import IconMap from "../components/Iconsvg/IconMap";
import IconRecords from "../components/Iconsvg/IconRecords";
import IconSettings from "../components/Iconsvg/IconSettings";
import IconUsers from "../components/Iconsvg/IconUsers";
// import IconProfile from '../components/Iconsvg/IconProfile';
import IconAlarm from "../components/Iconsvg/IconAlarm";
import IconWallet from "../components/Iconsvg/IconWallet.vue";
import IconReport from "../components/Iconsvg/IconReport.vue";
import IconLogOut from "../components/Iconsvg/IconLogOut.vue";
import IconGift from "../components/Iconsvg/IconGift.vue";
import IconEdit from "../components/Iconsvg/IconEdit.vue";
// import IconDownArrow from "../components/Iconsvg/IconDownArrow";
import IconDropdown from "../components/Iconsvg/IconDropdown";
import IconArrowBack from "../components/Iconsvg/IconArrowBack.vue";
import IconDownArrow from "../components/Iconsvg/IconDownArrow2.vue";
import IconSupport from "../components/Iconsvg/IconSupport.vue";
import Loading from "vue-loading-overlay";
import axios from "axios";
// import introJs from "intro.js";
// import "intro.js/introjs.css";
import "intro.js/minified/introjs.min.css";
import Terms from "../views/Modals/Terms.vue";

export default {
  name: "Container",
  components: {
    IconUsers,
    IconDashboard,
    IconGroups,
    IconDevices,
    // IconAudit,
    // IconDownArrow,
    IconAlarm,
    IconPower,
    IconRecords,
    IconSettings,
    // IconProfile,
    IconMap,
    IconWallet,
    IconReport,
    NewFeatureModal,
    IconLogOut,
    IconGift,
    IconEdit,
    IconDropdown,
    IconArrowBack,
    IconDownArrow,
    Loading,
    IconSupport,
    Terms,
  },
  data() {
    return {
      sidebarShow: false,
      headerShow: false,
      mobileSidebarSHow: false,
      profileIconShow: false,
      createPOI: false,
      createGeofence: false,
      POIdisabled: false,
      geofencedisabled: false,
      mapInner: false,
      newFeatureModal: false,
      side: false,
      prevRoute: "",
      previouPageName: "",
      // socket: socket,
      langs: ["en", "fr", "es"],
      language: "EN",
      show_drop: false,
      show_drop2: false,
      isLoading: false,
      fullPage: true,
      showSub: false,
      createSub: false,
      createWal: false,
      showRecs: false,
      showAgreement: false,
      // createSub: false,
      // createWal: false,
    };
  },
  mounted() {
    if (this.profile.language === "fr") {
      this.switchLang("fr", "FR");
    }
    if (this.profile.language === "en") {
      this.switchLang("en", "EN");
    }
    if (this.profile.language === "sw") {
      this.switchLang("sw", "SW");
    }
    if (this.showTerms) this.showAgreement = this.showTerms;
    this.newFeatureModal = this.popup;
    if (this.popup) this.side = this.popup;
    // this.getBusinessProfile();
    // Admin Panel settings
    $.fn.AdminSettings = function(settings) {
      var myid = this.attr("id");
      var AdminSettings = {
        // Settings INIT
        AdminSettingsInit: function() {
          AdminSettings.ManageThemeLayout();
          AdminSettings.ManageSidebarType();
          AdminSettings.ManageSidebarPosition();
        },
        ManageThemeLayout: function() {
          switch (settings.Layout) {
            case "vertical":
              $("#" + myid).attr("data-layout", "vertical");
              break;
            default:
          }
        },

        ManageSidebarType: function() {
          switch (settings.SidebarType) {
            case "full":
              $("#" + myid).attr("data-sidebartype", "full");
              var setsidebartype = function() {
                var width =
                  window.innerWidth > 0 ? window.innerWidth : this.screen.width;
                if (width < 992) {
                  $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                } else {
                  $("#main-wrapper").attr("data-sidebartype", "full");
                }
              };
              $(window).ready(setsidebartype);
              $(window).on("resize", setsidebartype);
              break;
            case "mini-sidebar":
              $("#" + myid).attr("data-sidebartype", "mini-sidebar");
              break;
            default:
          }
        },
        ManageSidebarPosition: function() {
          var sidebarposition = settings.SidebarPosition;
          var headerposition = settings.HeaderPosition;
          switch (settings.Layout) {
            case "vertical":
              if (sidebarposition == true) {
                $("#" + myid).attr("data-sidebar-position", "fixed");
                $("#sidebar-position").prop("checked", !0);
              } else {
                $("#" + myid).attr("data-sidebar-position", "absolute");
                $("#sidebar-position").prop("checked", !1);
              }
              if (headerposition == true) {
                $("#" + myid).attr("data-header-position", "fixed");
                $("#header-position").prop("checked", !0);
              } else {
                $("#" + myid).attr("data-header-position", "relative");
                $("#header-position").prop("checked", !1);
              }
              break;
            default:
          }
        },
      };
      AdminSettings.AdminSettingsInit();
    };
    $(function() {
      "use strict";
      $("#main-wrapper").AdminSettings({
        Layout: "vertical",
        SidebarType: "full", // You can change it full / mini-sidebar / iconbar / overlay
        SidebarPosition: true, // it can be true / false ( true means Fixed and false means absolute )
        HeaderPosition: true, // it can be true / false ( true means Fixed and false means absolute )
        BoxedLayout: false, // it can be true / false ( true means Boxed and false means Fluid )
      });
    });
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([
      "profile",
      "popup",
      "features",
      "lastPageData",
      "token",
      "businessprofile",
      "showTerms",
      "isShowTermsAndConditions",
    ]),
    getFirstLetter() {
      let fullName = this.profile?.fullname;
      let newVal;
      let acronym;
      let val = fullName?.split(" ");
      if (val) {
        let first = val[0];
        let second = val[1];
        if (second) {
          newVal = `${first} ${second}`;
        } else newVal = `${first}`;
        let matches = newVal?.match(/\b(\w)/g); // ['J','S','O','N']
        acronym = matches?.join(""); // JSON
      }
      return acronym;
    },
  },
  methods: {
    ...mapActions([
      "logout",
      "resetDevicesState",
      "resetBusinessProfileState",
      "resetProfileState",
      "resetNotificationsState",
      "resetUsersState",
      "resetSubscriptionsState",
      "resetDashboardState",
      "resetRecordsState",
      "resetAuthState",
      "resetDeveloperkeyState",
      "resetGroupsState",
      "openPopUp",
      "updateFeature",
      "getFeatures",
      "seenPopUp",
      "updatePageNumber",
      "getBusinessProfile",
      "fetchProfile",
      "updateTerms",
      "updateProfile",
    ]),
    currentModule() {
      return window.location.href.split("/")[3].replace("#", "");
    },
    isChildPage() {
      return window.location.href.split("/").length > 4;
    },
    closeNewFeatureModal() {
      this.newFeatureModal = false;
      if (this.popup) {
        this.openPopUp();
        this.side = false;
      }
      // this.updateFeature({ feature: 'popup' });
    },
    agreed() {
      this.isLoading = true;
      this.updateTerms()
        .then(() => {
          this.showAgreement = !this.showAgreement;
          this.isLoading = false;
        })
        .catch((err) => (this.isLoading = false));
    },
    logoutUser() {
      this.logout().then(() => this.$router.push("/login"));

      this.resetDevicesState();
      this.resetBusinessProfileState();
      this.resetProfileState();
      this.resetNotificationsState();
      this.resetUsersState();
      this.resetSubscriptionsState();
      this.resetDashboardState();
      this.resetRecordsState();
      this.resetAuthState();
      this.resetDeveloperkeyState();
      this.resetGroupsState();
      this.seenPopUp();
    },
    closeHeader() {
      this.headerShow = false;
      this.profileIconShow = false;
    },
    profileIcon() {
      this.profileIconShow = !this.profileIconShow;
      if (this.mobileSidebarSHow) {
        this.mobileSidebarSHow = false;
      }
    },
    mobileSidebar() {
      this.mobileSidebarSHow = !this.mobileSidebarSHow;
      if (this.profileIconShow) {
        this.profileIconShow = false;
      }
    },
    createpoi() {
      this.createPOI = true;
      this.createGeofence = false;
      this.mobileSidebarSHow = false;
    },
    creategeofence() {
      this.createPOI = false;
      this.createGeofence = true;
      this.mobileSidebarSHow = false;
    },
    createwal() {
      this.createWal = true;
      this.createSub = false;
      this.mobileSidebarSHow = false;
      this.$router.push("/wallet");
    },
    createsub() {
      this.createSub = true;
      this.createWal = false;
      this.mobileSidebarSHow = false;
      this.$router.push("/subscription");
    },
    createrec() {
      this.mobileSidebarSHow = false;
      this.$router.push("/records");
    },
    createDis() {
      this.mobileSidebarSHow = false;
      this.$router.push("/dispatch");
    },
    openSidePop() {
      this.openPopUp();
      this.side = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    switchLang: function(lang, val) {
      this.$i18n.locale = lang;
      this.language = val;
    },
    updateLang(lang) {
      this.isLoading = true;
      // axios({
      //   // url: "https://stage-gricd.herokuapp.com/v2/enterprise/alarms",
      //   url: `${process.env.VUE_APP_BASE_URI}/enterprise/language`,
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: this.token,
      //   },
      //   // data: formdata,
      //   data: { language: lang },
      // })
      const payload = {
        fullname: this.profile.fullname,
        // address: this.address,
        phone: `${this.profile.phone}`,
        language: lang,
      };
      this.updateProfile(payload)
        .then((res) => {
          console.log(res);
          this.isLoading = false;
          if (lang === "fr") {
            this.switchLang("fr", "FR");
            this.hideDrop();
          }
          if (lang === "en") {
            this.switchLang("en", "EN");
            this.hideDrop();
          }
          if (lang === "sw") {
            this.switchLang("sw", "SW");
            this.hideDrop();
          }
          this.fetchProfile();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    hideDrop() {
      this.show_drop = false;
    },
    hideDrop2() {
      this.show_drop2 = false;
    },
    declineAgreement() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.logoutUser();
      }, 1000);
    },
  },
  watch: {
    popup: {
      handler: function() {
        this.newFeatureModal = this.popup;
      },
      deep: true,
    },
    lastPageData: {
      handler: function() {
        this.previouPageName = this.lastPageData.lastPageName;
      },
    },
    isShowTermsAndConditions: {
      immediate: true,
      handler: function() {
        this.showAgreement = this.isShowTermsAndConditions;
      },
    },
    $route(to, from) {
      if (to.path === "/devices") {
        const path = from.path.split("/");
        if (path[1] !== "devices") {
          this.updatePageNumber({
            lastPageNumber: 1,
            lastPage: "",
            lastPageName: "",
          });
          this.previouPageName = "";
        }
      }
    },
  },
  beforeDestroy () {
    localStorage.removeItem('vuex');
  }
};
</script>

<style>
.sidebar-link:hover .container-icon > path,
.sidebar-link:hover .container-icon > rect,
.active-link .container-icon > path,
.active-link .container-icon > rect,
.router-link-active .container-icon > path,
.router-link-active .container-icon > rect {
  stroke: #213e7a;
}
.sidebar-link .container-icon {
  width: 24px;
  height: 20px;
}
</style>

<style scoped>
/* .left-sidebar {
  overflow: visible;
} */
.tooltip {
  position: relative;
}
.sidebar-item {
  position: relative;
  margin-bottom: 20px;
}
.sidebar-item .tooltiptext {
  width: 120px;
  top: 33%;
  left: 100%;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  display: none;
  position: absolute;
  z-index: 1300;
}
@media screen and (min-width: 991px) {
  .sidebar-item:hover .tooltiptext {
    display: block;
  }
  .move-right {
    margin-right: 2rem;
  }
  /* .hide-menu {
    display: none;
  } */
}
@media screen and (max-width: 576px) {
  .move-right {
    margin-right: 1rem;
  }
  .dropdown-lang {
    top: 4rem !important;
  }
  /* .hide-menu {
    display: none;
  } */
}
.sidebar-inneritem {
  cursor: pointer;
  background: #f3f6ff;
}
.sidebar-inneritem.show {
  cursor: default;
  background: #bdc5d9;
}
.geofence-disabled,
.poi-disabled {
  pointer-events: none;
}
.new-feat {
  color: white;
  font-weight: 300;
  background: #213e7a;
  border-radius: 5px;
  padding: 0.5px 5px 2px;
}
.circle {
  background: #5e6a79;
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
}
.inside-circle {
  font-size: 1.3rem;
  font-weight: bolder;
  color: white;
  margin: 0;
  text-transform: uppercase;
}
.name-text {
  font-size: 1rem;
  color: #5e6a79;
  font-weight: 500;
}
.hover-item {
  padding: 8px;
}
.hover-item:hover {
  background-color: #f6f8f9;
}
.back-btn {
  color: #213e7a;
  align-items: center;
  font-size: 1rem;
  column-gap: 0.5rem;
  cursor: pointer;
}
.dropdown-lang {
  background: #ffffff;
  border: 0.3px solid rgba(99, 99, 99, 0.25);
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 3 !important;
  top: 2rem;
  color: #5e6a79;
  /* width: calc(100% - 1.5rem); */
  width: max-content;
}
.introjs-fixParent {
  position: absolute !important;
}

/* .customTooltip .introjs-tooltip-title {
  color: red !important;
} */
</style>
